var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOssario(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.86 85.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5fba6d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.86,1v25.78H1V1h59.86m1-1H0v27.78h61.86V0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.86,58.32v25.78H1v-25.78h59.86m1-1H0v27.78h61.86v-27.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.23,8.91c2.75,0,4.99,2.24,4.99,4.99s-2.24,4.99-4.99,4.99-4.99-2.24-4.99-4.99,2.24-4.99,4.99-4.99m0-1c-3.31,0-5.99,2.68-5.99,5.99s2.68,5.99,5.99,5.99,5.99-2.68,5.99-5.99-2.68-5.99-5.99-5.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.23,66.23c2.75,0,4.99,2.24,4.99,4.99s-2.24,4.99-4.99,4.99-4.99-2.24-4.99-4.99,2.24-4.99,4.99-4.99m0-1c-3.31,0-5.99,2.68-5.99,5.99s2.68,5.99,5.99,5.99,5.99-2.68,5.99-5.99-2.68-5.99-5.99-5.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,28.66v27.78h61.86v-27.78H0Zm34.6,13.34h-2.8v8.83h-1.75v-8.83h-2.8v-1.72h2.8v-3.32h1.75v3.32h2.8v1.72Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOssario);
export default __webpack_public_path__ + "static/media/ossario.6ebf41c0f5310f6b0f3e69eb7f17b69e.svg";
export { ForwardRef as ReactComponent };